import { useSelector } from "react-redux";
import ReusableRegularization from "./resuableRegularization";
import { useEffect } from "react";
import { useLazyGetRegularizationHistoryQuery } from "../../api/regularizationApi";
import noDataRegularizationIcon from "../../Icons/noDataRegularizationIcon.svg";

const HistoryRegularization = ({ shouldGetManagerRecords }) => {
  const { regularizationHistory } = useSelector(
    (state) => state.regularization
  );
  const [getRegularizationHistory] = useLazyGetRegularizationHistoryQuery();
  console.log(regularizationHistory, "regula");
  useEffect(() => {
    const isEmployee = shouldGetManagerRecords;
    getRegularizationHistory(isEmployee);
  }, []);
  return (
    <div className="w-[97%] mx-5">
      {regularizationHistory.length === 0 ? (
        <div className="flex flex-col gap-5 items-center justify-center text-center pt-10 h-[90%] w-full">
          <img alt="NoData" width="400px" src={noDataRegularizationIcon} />
          <p className="font-medium">
            {
              "Once requests are processed or closed, they’ll show up in this tab."
            }
          </p>
        </div>
      ) : (
        regularizationHistory.map((each) => (
          <ReusableRegularization data={each} />
        ))
      )}
    </div>
  );
};

export default HistoryRegularization;
